<template>
  <!-- <div class="flex-align">
    <div class="no-data flex-center">
      <img :src="require('@/assets/images/no-content.png')" alt="" />
      <span class="no-data__content">{{ title }}</span>
    </div>
  </div> -->
  <div class="no-data">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'ApplyNoContent',

  props: {
    title: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  color: $third-text-color;
  font-size: 14px;
}
</style>
